import { useCallback, useEffect, useRef, useState } from "react";
import {
  getFieldValuesByTableAndId,
  getOtherRefDetails,
  getOtherRefSearchDropdown,
  getTextByValueAndKey,
} from "../../../../api/keyvalue";
import { validateRequestLocation } from "../../../validations/validateRequestCreation";
import SearchDropdown from "../../../input/SearchDropdown";

import {
  formatFromJsonDate,
  isAfter,
  isAfterJson,
  isBefore,
} from "../../../../dateConfig";
import { Info, MapPin } from "react-feather";
import Grid from "../../../Grid";
import ButtonRenderer from "../../../renderer/ButtonRenderer";
import DateTimePickerInput from "../../../input/DateTimePickerInput";
import UIMessage from "../../../UIMessage";
import { useDispatch, useSelector } from "react-redux";
import { requestActions } from "../../../../store/request-slice";
import Modal from "../../../Modal";
import LocationDetails from "../../LocationDetails";
import Button from "../../../input/Button";
import { ResizableScrollingTextRenderer } from "../../../renderer/StyleRenderer";
import { AUTH_TYPES, FORMS, MODULES } from "../../../../const";
import { isNumber } from "../../../../helper";
import { toast } from "react-toastify";
import { validateQuickRequestLocation } from "../../../validations/ValidateQuickRequestCreation";
import DeleteButtonRenderer from "../../../renderer/DeleteButtonRenderer";

const FORM = FORMS.QUICK_REQUEST.LOCATION.form;
const MAIN_FORM = FORMS.QUICK_REQUEST.CREATION.form;

const QuickRequestLocation = ({ editMode, onShowLocation }) => {
  const auth = useSelector(
    (state) => state.user.permissions[MODULES.Transaction]
  );

  const customerId = useSelector((state) => state.request.reqLCustomerId);

  const mainFormPermissions = auth?.[MAIN_FORM];
  const allowBackDates = mainFormPermissions?.FORM?.REQUEST_BACK_DATE;

  const startLocationRef = useRef();
  const endLocationRef = useRef();

  const locations = useSelector(
    (state) => state.request.requestLocationsRequests
  );

  const reqBookingRequiredDate = useSelector(
    (state) => state.request.reqBookingRequiredDate
  );

  const viaLocationRef = useRef();

  const [seq, setSeq] = useState(2);

  const [requestStartLocation, setRequestStartLocation] = useState({
    rlkLocation: null,
    rlkLocationType: 1,
    rlkArrivalEta: "",
    rlkArrivalEtaFormatted: "",
    rlkDepartureEta: "",
    rlkDepartureEtaFormatted: "",
    locationName: "",
    rlkLoadingTime: null,
    rlkUnloadingTime: null,
    rlkContactPersonId: null,
    rlkAddress: "",
    rlkContactNumber: "",
    rlkEmail: "",
    rlkLon: "",
    rlkLat: "",
    rlkActive: 1,
    rlkSeq: 1,
    requestConsigneesRequests: [],
  });

  const [requestEndLocation, setRequestEndLocation] = useState({
    rlkLocation: null,
    rlkLocationType: 2,
    rlkArrivalEta: "",
    rlkArrivalEtaFormatted: "",
    rlkDepartureEta: "",
    rlkDepartureEtaFormatted: "",
    locationName: "",
    rlkLoadingTime: null,
    rlkUnloadingTime: null,
    rlkContactPersonId: null,
    rlkAddress: "",
    rlkContactNumber: "",
    rlkEmail: "",
    rlkLon: "",
    rlkLat: "",
    rlkActive: 1,
    rlkSeq: seq + 1,
    requestConsigneesRequests: [],
  });

  const [items, setItems] = useState([]);

  const [requestViaLocation, setRequestViaLocation] = useState({
    rlkLocation: null,
    rlkLocationType: 3,
    rlkArrivalEta: "",
    rlkArrivalEtaFormatted: "",
    rlkDepartureEta: "",
    rlkDepartureEtaFormatted: "",
    locationName: "",
    rlkLoadingTime: null,
    rlkUnloadingTime: null,
    rlkContactPersonId: null,
    rlkAddress: "",
    rlkContactNumber: "",
    rlkEmail: "",
    rlkLon: "",
    rlkLat: "",
    rlkSeq: null,
    rlkActive: 1,
    requestConsigneesRequests: [],
  });

  const [popupContentConst, setPopUpContentConst] = useState();

  const modalRef = useRef();
  const startLocationErrors = useSelector(
    (state) => state.request.startLocationErrors
  );
  const endLocationErrors = useSelector(
    (state) => state.request.endLocationErrors
  );
  const validationErrors = useSelector(
    (state) => state.request.validationErrors
  );

  const [currentStartLocationErrors, setCurrentStartLocationErrors] =
    useState(startLocationErrors);
  const [currentEndLocationErrors, setCurrentEndLocationErrors] =
    useState(endLocationErrors);

  useEffect(() => {
    setCurrentStartLocationErrors(startLocationErrors);
  }, [startLocationErrors]);

  useEffect(() => {
    setCurrentEndLocationErrors(endLocationErrors);
  }, [endLocationErrors]);

  const [isAddLoading, setIsAddLoading] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [errors, setErrors] = useState("");
  const [count, setCount] = useState(2);
  const [currentItem, setCurrentItem] = useState({});
  const [dragStart, setDragStart] = useState(null);
  const [dragStop, setDragStop] = useState(null);
  const [rowDragDroped, setRowDragDroped] = useState(false);
  const [gridLoading, setGridLoading] = useState(false);

  const [searchFieldReset, setSearchFieldReset] = useState(false);
  const [viaSearchFieldReset, setViaSearchFieldReset] = useState(false);
  const dispatch = useDispatch();

  const [currentViaLocations, setCurrentViaLocations] = useState([]);

  const getAllLocationWOEndLocMap = () => {
    let locationMap =
      requestStartLocation.rlkLocation === null
        ? {}
        : { 1: requestStartLocation.rlkLocation };
    for (const via of items) {
      locationMap = { ...locationMap, [via.rlkSeq]: via.rlkLocation };
    }

    return locationMap;
  };

  const isLocationOrderInvalid = (locSeq, rlkId) => {
    let allLocationMap = getAllLocationWOEndLocMap();
    allLocationMap = { ...allLocationMap, [locSeq]: rlkId };
    if (requestEndLocation.rlkLocation !== null) {
      allLocationMap = {
        ...allLocationMap,
        [locSeq === seq ? seq + 1 : seq]: requestEndLocation.rlkLocation,
      };
    }
    return haveConsecutiveLocations(allLocationMap);
  };

  const haveConsecutiveLocations = (locationMap) => {
    let prevLocation = locationMap[1];
    for (let i = 2; i <= seq + 1; i++) {
      const currentLocation =
        locationMap[i] === undefined ? -1 : locationMap[i];
      if (currentLocation === -1) {
        return false;
      }
      if (currentLocation === prevLocation) {
        return true;
      }
      prevLocation = currentLocation;
    }
    return false;
  };

  const organizeLocations = (locations) => {
    let startLocation = null;
    let endLocation = null;
    let viaLocations = [];

    locations.forEach((location) => {
      if (location.rlkLocationType === 1 && !startLocation) {
        startLocation = location;
      } else if (location.rlkLocationType === 2 && !endLocation) {
        endLocation = location;
      } else if (location.rlkLocationType === 3) {
        viaLocations.push(location);
      }
    });

    // Remove duplicates or unnecessary repetitions if needed
    return { startLocation, viaLocations, endLocation };
  };

  useEffect(() => {
    if (rowDragDroped) {
      if (dragStart === dragStop) {
        setRowDragDroped(false);
        setDragStart(null);
        setDragStop(null);
        return;
      }
      let locationsToUpdate = [];
      let updatedLocations = [];
      setGridLoading(true);
      if (dragStop < dragStart) {
        locationsToUpdate = items
          .filter((location) => {
            return location.rlkSeq >= dragStop && location.rlkSeq <= dragStart;
          })
          .sort((a, b) => a.rlkSeq - b.rlkSeq);
        const dragStartLocation =
          locationsToUpdate[locationsToUpdate.length - 1];
        const dragStopLocation = locationsToUpdate[0];

        updatedLocations.push({
          ...dragStartLocation,
          rlkSeq: dragStopLocation.rlkSeq,
          rlkArrivalEta: dragStopLocation.rlkArrivalEta,
          rlkArrivalEtaFormatted: dragStopLocation.rlkArrivalEtaFormatted,
          rlkDepartureEta: dragStopLocation.rlkDepartureEta,
          rlkDepartureEtaFormatted: dragStopLocation.rlkDepartureEtaFormatted,
        });
        let prevLocation = locationsToUpdate[1];
        for (let i = 1; i < locationsToUpdate.length; i++) {
          let currentLocation = locationsToUpdate[i];
          if (i === 1) {
            updatedLocations.push({
              ...dragStopLocation,
              rlkSeq: prevLocation.rlkSeq,
              rlkArrivalEta: prevLocation.rlkArrivalEta,
              rlkArrivalEtaFormatted: prevLocation.rlkArrivalEtaFormatted,
              rlkDepartureEta: prevLocation.rlkDepartureEta,
              rlkDepartureEtaFormatted: prevLocation.rlkDepartureEtaFormatted,
            });
          } else {
            updatedLocations.push({
              ...prevLocation,
              rlkSeq: currentLocation.rlkSeq,
              rlkArrivalEta: currentLocation.rlkArrivalEta,
              rlkArrivalEtaFormatted: currentLocation.rlkArrivalEtaFormatted,
              rlkDepartureEta: currentLocation.rlkDepartureEta,
              rlkDepartureEtaFormatted:
                currentLocation.rlkDepartureEtaFormatted,
            });
            prevLocation = currentLocation;
          }
        }
        for (let location of items) {
          if (location.rlkSeq < dragStop || location.rlkSeq > dragStart) {
            updatedLocations.push(location);
          }
        }
      } else {
        locationsToUpdate = items
          .filter((location) => {
            return location.rlkSeq >= dragStart && location.rlkSeq <= dragStop;
          })
          .sort((a, b) => a.rlkSeq - b.rlkSeq);
        const dragStartLocation = locationsToUpdate[0];
        const dragStopLocation =
          locationsToUpdate[locationsToUpdate.length - 1];

        updatedLocations.push({
          ...dragStartLocation,
          rlkSeq: dragStopLocation.rlkSeq,
          rlkArrivalEta: dragStopLocation.rlkArrivalEta,
          rlkArrivalEtaFormatted: dragStopLocation.rlkArrivalEtaFormatted,
          rlkDepartureEta: dragStopLocation.rlkDepartureEta,
          rlkDepartureEtaFormatted: dragStopLocation.rlkDepartureEtaFormatted,
        });
        let prevLocation = locationsToUpdate[locationsToUpdate.length - 2];
        for (let i = locationsToUpdate.length - 2; i >= 0; i--) {
          let currentLocation = locationsToUpdate[i];
          if (i === locationsToUpdate.length - 2) {
            updatedLocations.push({
              ...dragStopLocation,
              rlkSeq: prevLocation.rlkSeq,
              rlkArrivalEta: prevLocation.rlkArrivalEta,
              rlkArrivalEtaFormatted: prevLocation.rlkArrivalEtaFormatted,
              rlkDepartureEta: prevLocation.rlkDepartureEta,
              rlkDepartureEtaFormatted: prevLocation.rlkDepartureEtaFormatted,
            });
          } else {
            updatedLocations.push({
              ...prevLocation,
              rlkSeq: currentLocation.rlkSeq,
              rlkArrivalEta: currentLocation.rlkArrivalEta,
              rlkArrivalEtaFormatted: currentLocation.rlkArrivalEtaFormatted,
              rlkDepartureEta: currentLocation.rlkDepartureEta,
              rlkDepartureEtaFormatted:
                currentLocation.rlkDepartureEtaFormatted,
            });
            prevLocation = currentLocation;
          }
        }

        for (let location of items) {
          if (location.rlkSeq < dragStart || location.rlkSeq > dragStop) {
            updatedLocations.push(location);
          }
        }
      }
      const sortedLocations = updatedLocations.sort(
        (a, b) => a.rlkSeq - b.rlkSeq
      );
      let locationMap = {
        1: requestStartLocation.rlkLocation,
        ...sortedLocations.reduce((acc, item) => {
          acc[item.rlkSeq] = item.rlkLocation;
          return acc;
        }, {}),
      };
      if (requestEndLocation.rlkLocation !== null) {
        locationMap = { ...locationMap, [seq]: requestEndLocation.rlkLocation };
      }
      if (haveConsecutiveLocations(locationMap)) {
        toast.warn("Invalid Location order", {
          autoClose: 5000,
          containerId: "Main",
        });
        setRowDragDroped(false);
        setGridLoading(false);
        return;
      }
      setItems(sortedLocations);
      dispatch(requestActions.updateLocations(sortedLocations));
      setRowDragDroped(false);
      setGridLoading(false);
    }
  }, [rowDragDroped, items, dragStart, dragStop, dispatch]);

  const onRowDragEnter = useCallback((e) => {
    setDragStart(e.overIndex + 2);
  }, []);

  const onRowDragEnd = useCallback((e) => {
    setDragStop(e.overIndex + 2);
    setRowDragDroped(true);
  }, []);

  const locationCustomerId = useSelector(
    (state) => state.request.reqLCustomerId
  );

  console.log("location customer", locationCustomerId);

  const viewOnlyMode = useSelector((state) => state.request.viewOnlyMode);

  const currentData = useSelector(
    (state) => state.request.currentValues.requestLocations
  );

  const getPreviousLocation = (curreSeq) => {
    const viaLocations = items.filter((item) => item.rlkLocationType === 3);

    if (!curreSeq) {
      curreSeq = seq;
    }

    for (let i = curreSeq - 1; i > 1; i--) {
      const location = viaLocations.find((item) => item.rlkSeq === i);
      if (location) {
        return location;
      }
    }
    return null;
  };

  const getFirstViaLocation = () => {
    const viaLocations = items.filter((item) => item.rlkLocationType === 3);
    for (let i = 2; i <= seq; i++) {
      const location = viaLocations.find((item) => item.rlkSeq === i);
      if (location) {
        return location;
      }
    }
    return null;
  };

  useEffect(() => {
    const { viaLocations, endLocation } = organizeLocations(locations);

    // Set the states for start, via, and end locations
    // setRequestStartLocation(startLocation);
    setRequestEndLocation(endLocation);
    setItems(viaLocations); // this assumes `setItems` updates your via location grid
  }, [locations]);

  useEffect(() => {
    (async () => {
      if (editMode && currentData) {
        setCurrentViaLocations(
          currentData
            ? currentData?.requestViaLocations
              ? [...currentData?.requestViaLocations].sort(
                  (a, b) => a.rlkSeq - b.rlkSeq
                )
              : []
            : []
        );
        setRequestStartLocation({
          ...currentData?.requestStartLocation,
        });
        setRequestEndLocation({
          ...currentData?.requestEndLocation,
        });
      }
    })();
  }, [currentData, editMode, locationCustomerId]);

  useEffect(() => {
    (async () => {
      if (editMode) {
        let currentLocs = [];
        let id = 4;
        let sequence = 2;
        for (let value of currentViaLocations) {
          currentLocs.push({
            ...value,
          });
          id++;
          sequence++;
        }

        setCount(id);
        setSeq(sequence);
        setItems(currentLocs);
      }
    })();
  }, [editMode, currentViaLocations, locationCustomerId, setSeq]);

  useEffect(() => {
    if (Object.keys(currentItem).length > 0) {
      setRequestViaLocation({
        ...currentItem,
      });
    }
  }, [editMode, currentItem, setRequestViaLocation]);

  useEffect(() => {
    if (buttonClicked) {
      setRequestViaLocation({
        rlkLocation: null,
        rlkLocationType: 3,
        rlkArrivalEta: "",
        rlkArrivalEtaFormatted: "",
        rlkDepartureEta: "",
        rlkDepartureEtaFormatted: "",
        rlkLoadingTime: null,
        rlkUnloadingTime: null,
        rlkContactPersonId: null,
        rlkContactPersonValue: "",
        rlkAddress: "",
        rlkContactNumber: "",
        locationName: "",
        rlkEmail: "",
        rlkLon: "",
        rlkLat: "",
        rlkSeq: null,
        rlkActive: 1,
        requestConsigneesRequests: [],
      });
      setViaSearchFieldReset(true);
      setErrors({});
      setCurrentItem({});
      setButtonClicked(false);
    }
  }, [buttonClicked, setRequestViaLocation]);

  let popUpContent = <></>;

  const popupConst = {
    MAP_LOCATION: "MAP_LOCATION",
    START_LOCATION_DETAILS: "START_LOCATION_DETAILS",
    END_LOCATION_DETAILS: "END_LOCATION_DETAILS",
    VIA_LOCATION_DETAILS: "VIA_LOCATION_DETAILS",
  };

  switch (popupContentConst) {
    case popupConst.MAP_LOCATION: {
      popUpContent = <></>;
      break;
    }
    case popupConst.START_LOCATION_DETAILS: {
      popUpContent = (
        <LocationDetails
          locationId={requestStartLocation?.rlkLocation}
          locationCustomerId={locationCustomerId}
        />
      );
      break;
    }
    case popupConst.END_LOCATION_DETAILS: {
      popUpContent = (
        <LocationDetails
          locationId={requestEndLocation?.rlkLocation}
          locationCustomerId={locationCustomerId}
        />
      );
      break;
    }
    case popupConst.VIA_LOCATION_DETAILS: {
      popUpContent = (
        <LocationDetails
          locationId={requestViaLocation.rlkLocation}
          locationCustomerId={locationCustomerId}
        />
      );
      break;
    }
    default:
      popUpContent = <></>;
  }

  const openPopUp = (content) => {
    setPopUpContentConst(content);
    modalRef.current?.showModal();
  };

  const getLabelData = async () => {
    const locationResponse = await getOtherRefDetails({
      type: "location_customer",
      value: locationCustomerId?.toString(),
      param2: requestViaLocation.rlkLocation?.toString(),
    });
    const locationDetails =
      locationResponse && locationResponse.length > 0
        ? locationResponse[0]
        : {};

    const rlkLocationTypeValue = await getTextByValueAndKey(
      "rlk_location",
      requestViaLocation.rlkLocationType
    );

    const contactPersonResponse = requestViaLocation.rlkContactPersonId
      ? await getFieldValuesByTableAndId({
          tableName: "masterdata.tms_m_contacts",
          ids: requestViaLocation.rlkContactPersonId?.toString(),
          primaryKey: "con_id",
          fieldNames: "con_name",
        })
      : null;

    const rlkContactPersonValue = contactPersonResponse
      ? contactPersonResponse[0].field1
      : "";

    return { locationDetails, rlkLocationTypeValue, rlkContactPersonValue };
  };

  const onAddClick = async () => {
    setIsAddLoading(true);

    const requestLocationErrors =
      validateQuickRequestLocation(requestViaLocation);

    const prevLocation = getPreviousLocation(requestViaLocation.rlkSeq);

    if (Object.keys(requestLocationErrors).length === 0) {
      // Validate departure date is after arrival date
      if (
        isAfterJson(
          requestViaLocation.rlkArrivalEta,
          requestViaLocation.rlkDepartureEta
        )
      ) {
        requestLocationErrors.rlkDepartureEta =
          "Departure date should be after arrival date";
        setErrors(requestLocationErrors);
        document.querySelector(".ui.form").classList.add("error");
        setIsAddLoading(false);
        return;
      }

      // Validate arrival time after the previous location's departure time
      if (prevLocation) {
        if (
          !isAfterJson(
            requestViaLocation.rlkArrivalEta,
            prevLocation.rlkDepartureEta
          )
        ) {
          requestLocationErrors.rlkArrivalEta =
            "Arrival date should be after previous location departure date";
          setErrors(requestLocationErrors);
          document.querySelector(".ui.form").classList.add("error");
          setIsAddLoading(false);
          return;
        }
      }

      if (!requestViaLocation.rlkId) {
        if (!requestViaLocation.id) {
          if (isLocationOrderInvalid(seq, requestViaLocation.rlkLocation)) {
            toast.warn("Invalid Location order", {
              autoClose: 5000,
              containerId: "Main",
            });
            setIsAddLoading(false);
            return;
          }
          const {
            locationDetails,
            rlkLocationTypeValue,
            rlkContactPersonValue,
          } = await getLabelData();
          setItems((prevState) => [
            ...prevState,
            {
              ...requestViaLocation,
              locationName: locationDetails.retField1,
              rlkAddress: locationDetails.retField2,
              rlkEmail: locationDetails.retField6,
              rlkContactNumber: locationDetails.retField5,
              rlkLon: locationDetails.retField10,
              rlkLat: locationDetails.retField9,
              rlkLocationTypeValue,
              rlkContactPersonValue,
              rlkSeq: seq,
              id: count,
            },
          ]);
          dispatch(
            requestActions.addLocation({
              ...requestViaLocation,
              locationName: locationDetails.retField1,
              rlkAddress: locationDetails.retField2,
              rlkEmail: locationDetails.retField6,
              rlkContactNumber: locationDetails.retField5,
              rlkLon: locationDetails.retField9,
              rlkLat: locationDetails.retField10,
              rlkLocationTypeValue,
              rlkContactPersonValue,
              rlkSeq: seq,
              id: count,
            })
          );
          setSeq((prevState) => prevState + 1);
          setCount((prevState) => prevState + 1);
        } else {
          if (
            isLocationOrderInvalid(
              requestViaLocation.rlkSeq,
              requestViaLocation.rlkLocation
            )
          ) {
            toast.warn("Invalid Location order", {
              autoClose: 5000,
              containerId: "Main",
            });
            setIsAddLoading(false);
            return;
          }
          const {
            locationDetails,
            rlkLocationTypeValue,
            rlkContactPersonValue,
          } = await getLabelData();
          setItems((prevState) =>
            prevState.filter(
              (container) => container.id !== requestViaLocation.id
            )
          );

          setItems((prevState) => [
            ...prevState,
            {
              ...requestViaLocation,
              locationName: locationDetails.retField1,
              rlkAddress: locationDetails.retField2,
              rlkEmail: locationDetails.retField6,
              rlkContactNumber: locationDetails.retField5,
              rlkLon: locationDetails.retField9,
              rlkLat: locationDetails.retField10,
              rlkContactPersonValue,
              rlkLocationTypeValue,
            },
          ]);

          dispatch(
            requestActions.updateNonPersistedLocation({
              id: requestViaLocation.id,
              location: {
                ...requestViaLocation,
                locationName: locationDetails.retField1,
                rlkAddress: locationDetails.retField2,
                rlkEmail: locationDetails.retField6,
                rlkContactNumber: locationDetails.retField5,
                rlkLon: locationDetails.retField9,
                rlkLat: locationDetails.retField10,
                rlkContactPersonValue,
                rlkLocationTypeValue,
              },
            })
          );
        }
      } else {
        if (
          isLocationOrderInvalid(
            requestViaLocation.rlkSeq,
            requestViaLocation.rlkLocation
          )
        ) {
          toast.warn("Invalid Location order", {
            autoClose: 5000,
            containerId: "Main",
          });
          setIsAddLoading(false);
          return;
        }
        const { locationDetails, rlkLocationTypeValue, rlkContactPersonValue } =
          await getLabelData();
        setItems((prevState) =>
          prevState.map((loc) => {
            if (loc.rlkId === requestViaLocation.rlkId) {
              return {
                ...requestViaLocation,
                locationName: locationDetails.retField1,
                rlkAddress: locationDetails.retField2,
                rlkEmail: locationDetails.retField6,
                rlkContactNumber: locationDetails.retField5,
                rlkLon: locationDetails.retField9,
                rlkLat: locationDetails.retField10,
                rlkContactPersonValue,
                rlkLocationTypeValue,
              };
            }
            return loc;
          })
        );
        dispatch(
          requestActions.updatePersistedLocation({
            rlkId: requestViaLocation.rlkId,
            location: {
              ...requestViaLocation,
              locationName: locationDetails.retField1,
              rlkAddress: locationDetails.retField2,
              rlkEmail: locationDetails.retField6,
              rlkContactNumber: locationDetails.retField5,
              rlkLon: locationDetails.retField9,
              rlkLat: locationDetails.retField10,
              rlkContactPersonValue,
              rlkLocationTypeValue,
            },
          })
        );
      }
      setButtonClicked(true);
    } else {
      setErrors(requestLocationErrors);
      document.querySelector(".ui.form").classList.add("error");
    }
    setIsAddLoading(false);
  };

  return (
    <div>
      <Modal ref={modalRef}>{popUpContent}</Modal>
      <form className="ui form">
        <div className="ui segment">
          <div className="field">
            <div className="ui segment">
              <h4 className="ui dividing header">Start Location</h4>
              <div className="two fields">
                <SearchDropdown
                  readOnly={viewOnlyMode}
                  editMode={editMode}
                  multiGrid={true}
                  multiGridCurrentValue={requestStartLocation?.locationName}
                  form={FORM}
                  module={MODULES.Transaction}
                  field="rlk_start_location"
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  api={getOtherRefDetails}
                  returnFullObject={true}
                  ref={startLocationRef}
                  threshold={1}
                  apiDependency={{
                    type: "location_customer",
                    value: locationCustomerId?.toString(),
                  }}
                  clearable={true}
                  onClear={() => {
                    dispatch(
                      requestActions.setStartLocation({
                        locationName: "",
                        rlkAddress: "",
                        rlkEmail: "",
                        rlkContactNumber: "",
                        rlkLon: null,
                        rlkLat: null,
                        rlkLocation: null,
                      })
                    );
                    setRequestStartLocation((prevState) => ({
                      ...prevState,
                      locationName: "",
                      rlkAddress: "",
                      rlkEmail: "",
                      rlkContactNumber: "",
                      rlkLon: null,
                      rlkLat: null,
                      rlkLocation: null,
                    }));
                  }}
                  onResultSelect={(data) => {
                    if (isLocationOrderInvalid(1, data.value)) {
                      toast.warn("Invalid Location order", {
                        autoClose: 5000,
                        containerId: "Main",
                      });
                      startLocationRef?.current?.reset();
                      return;
                    }
                    dispatch(
                      requestActions.setStartLocation({
                        locationName: data.retField1,
                        rlkAddress: data.retField2,
                        rlkEmail: data.retField6,
                        rlkContactNumber: data.retField5,
                        rlkLon: data.retField9,
                        rlkLat: data.retField10,
                        rlkLocation: data.value,
                      })
                    );
                    setRequestStartLocation((prevState) => ({
                      ...prevState,
                      locationName: data.retField1,
                      rlkAddress: data.retField2,
                      rlkEmail: data.retField6,
                      rlkContactNumber: data.retField5,
                      rlkLon: data.retField9,
                      rlkLat: data.retField10,
                      rlkLocation: data.value,
                    }));
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_locations",
                    primaryKey: "loc_id",
                    fieldName: "loc_name",
                    id: requestStartLocation?.rlkLocation,
                  }}
                  required={true}
                  label="Location"
                  error={currentStartLocationErrors.rlkLocation}
                  resetError={() =>
                    setCurrentStartLocationErrors((prevState) => {
                      const { rlkLocation: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />
                <DateTimePickerInput
                  readOnly={viewOnlyMode}
                  form={FORM}
                  module={MODULES.Transaction}
                  field="rlk_start_arrival_eta"
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  value={requestStartLocation?.rlkArrivalEta}
                  style={{
                    borderColor: errors.departureTime ? "red" : "",
                  }}
                  onAccept={(value) => {
                    dispatch(
                      requestActions.setStartLocation({
                        rlkArrivalEta: value,
                      })
                    );
                    if (!reqBookingRequiredDate) {
                      dispatch(
                        requestActions.setRequest({
                          reqBookingRequiredDate: value,
                        })
                      );
                    }
                    setRequestStartLocation((prevState) => ({
                      ...prevState,
                      rlkArrivalEta: value,
                      rlkArrivalEtaFormatted: formatFromJsonDate(value),
                    }));
                  }}
                  validators={
                    !allowBackDates
                      ? [
                          {
                            func: (date) => isAfter(date, new Date()),
                            message:
                              "Date and time should be after current date and time",
                          },
                          {
                            func: (date) => {
                              if (requestStartLocation?.rlkDepartureEta) {
                                return isBefore(
                                  date,
                                  requestStartLocation?.rlkDepartureEta
                                );
                              }

                              return true;
                            },
                            message:
                              "Arrival Date should be before departure date",
                          },
                          {
                            func: (date) => {
                              if (requestEndLocation?.rlkArrivalEta) {
                                return isBefore(
                                  date,
                                  requestEndLocation?.rlkArrivalEta
                                );
                              }

                              return true;
                            },
                            message: "Date should be before End location date",
                          },
                          {
                            func: (date) => {
                              const firstViaLocation = getFirstViaLocation();
                              if (firstViaLocation) {
                                return isBefore(
                                  date,
                                  firstViaLocation.rlkArrivalEta
                                );
                              }
                              return true;
                            },
                            message: "Date should be before first Via location",
                          },
                        ]
                      : [
                          {
                            func: (date) => {
                              if (requestStartLocation?.rlkDepartureEta) {
                                return isBefore(
                                  date,
                                  requestStartLocation?.rlkDepartureEta
                                );
                              }

                              return true;
                            },
                            message:
                              "Arrival Date should be before departure date",
                          },
                          {
                            func: (date) => {
                              if (requestEndLocation?.rlkArrivalEta) {
                                return isBefore(
                                  date,
                                  requestEndLocation?.rlkArrivalEta
                                );
                              }

                              return true;
                            },
                            message: "Date should be before End location date",
                          },
                          {
                            func: (date) => {
                              const firstViaLocation = getFirstViaLocation();
                              if (firstViaLocation) {
                                return isBefore(
                                  date,
                                  firstViaLocation.rlkArrivalEta
                                );
                              }
                              return true;
                            },
                            message: "Date should be before first Via location",
                          },
                        ]
                  }
                  label="Arrival"
                  error={currentStartLocationErrors.rlkArrivalEta}
                  resetError={() =>
                    setCurrentStartLocationErrors((prevState) => {
                      const { rlkArrivalEta: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  required={true}
                />
                <DateTimePickerInput
                  readOnly={viewOnlyMode}
                  form={FORM}
                  module={MODULES.Transaction}
                  field="rlk_start_departure_eta"
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  value={requestStartLocation?.rlkDepartureEta}
                  style={{
                    borderColor: errors.departureTime ? "red" : "",
                  }}
                  onAccept={(value) => {
                    dispatch(
                      requestActions.setStartLocation({
                        rlkDepartureEta: value,
                      })
                    );
                    setRequestStartLocation((prevState) => ({
                      ...prevState,
                      rlkDepartureEta: value,
                      rlkDepartureEtaFormatted: formatFromJsonDate(value),
                    }));
                  }}
                  validators={
                    !allowBackDates
                      ? [
                          {
                            func: (date) => isAfter(date, new Date()),
                            message:
                              "Date and Time should be after current date and time",
                          },
                          {
                            func: (date) =>
                              isAfter(
                                date,
                                requestStartLocation?.rlkArrivalEta
                              ),
                            message: "Date should be after arrival date",
                          },
                        ]
                      : [
                          {
                            func: (date) =>
                              isAfter(
                                date,
                                requestStartLocation?.rlkArrivalEta
                              ),
                            message: "Date should be after arrival date",
                          },
                        ]
                  }
                  label="Departure"
                  error={currentStartLocationErrors.rlkDepartureEta}
                  resetError={() =>
                    setCurrentStartLocationErrors((prevState) => {
                      const { rlkDepartureEta: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  required={true}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "flex-end",
                  marginTop: "5px",
                }}
              >
                <Button
                  disabled={!requestStartLocation?.rlkLocation}
                  className="ui primary right floated button"
                  label="Location Details"
                  onClick={() => {
                    openPopUp(popupConst.START_LOCATION_DETAILS);
                  }}
                  Icon={Info}
                />
              </div>
            </div>
            <div className="ui segment">
              <h4 className="ui dividing header">End Location</h4>
              <div className="two fields">
                <SearchDropdown
                  readOnly={viewOnlyMode}
                  disabled={
                    !requestStartLocation?.rlkArrivalEta ||
                    !requestStartLocation?.rlkDepartureEta
                  }
                  editMode={editMode}
                  multiGrid={true}
                  multiGridCurrentValue={requestEndLocation?.locationName}
                  reset={searchFieldReset}
                  form={FORM}
                  module={MODULES.Transaction}
                  field="rlk_end_location"
                  setReset={setSearchFieldReset}
                  api={getOtherRefDetails}
                  ref={endLocationRef}
                  returnFullObject={true}
                  threshold={1}
                  apiDependency={{
                    type: "location_customer",
                    value: locationCustomerId?.toString(),
                  }}
                  clearable={true}
                  onClear={() => {
                    dispatch(
                      requestActions.setEndLocation({
                        locationName: "",
                        rlkAddress: "",
                        rlkEmail: "",
                        rlkContactNumber: "",
                        rlkLon: null,
                        rlkLat: null,
                        rlkLocation: null,
                      })
                    );
                    setRequestEndLocation((prevState) => ({
                      ...prevState,
                      locationName: "",
                      rlkAddress: "",
                      rlkEmail: "",
                      rlkContactNumber: "",
                      rlkLon: null,
                      rlkLat: null,
                      rlkLocation: null,
                    }));
                  }}
                  onResultSelect={(data) => {
                    if (isLocationOrderInvalid(seq, data.value)) {
                      toast.warn("Invalid Location order", {
                        autoClose: 5000,
                        containerId: "Main",
                      });
                      endLocationRef?.current?.reset();
                      return;
                    }
                    dispatch(
                      requestActions.setEndLocation({
                        locationName: data.retField1,
                        rlkAddress: data.retField2,
                        rlkEmail: data.retField6,
                        rlkContactNumber: data.retField5,
                        rlkLon: data.retField9,
                        rlkLat: data.retField10,
                        rlkLocation: data.value,
                      })
                    );
                    setRequestEndLocation((prevState) => ({
                      ...prevState,
                      locationName: data.retField1,
                      rlkAddress: data.retField2,
                      rlkEmail: data.retField6,
                      rlkContactNumber: data.retField5,
                      rlkLon: data.retField9,
                      rlkLat: data.retField10,
                      rlkLocation: data.value,
                    }));
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_locations",
                    primaryKey: "loc_id",
                    fieldName: "loc_name",
                    id: requestEndLocation?.rlkLocation,
                  }}
                  required={true}
                  label="Location"
                  error={currentStartLocationErrors.rlkLocation}
                  resetError={() =>
                    setCurrentStartLocationErrors((prevState) => {
                      const { rlkLocation: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />
                <DateTimePickerInput
                  readOnly={viewOnlyMode}
                  form={FORM}
                  module={MODULES.Transaction}
                  field="rlk_end_arrival_eta"
                  disabled={
                    !requestStartLocation?.rlkArrivalEta ||
                    !requestStartLocation?.rlkDepartureEta
                  }
                  value={requestEndLocation?.rlkArrivalEta}
                  style={{
                    borderColor: errors.departureTime ? "red" : "",
                  }}
                  onAccept={(value) => {
                    dispatch(
                      requestActions.setEndLocation({
                        rlkArrivalEta: value,
                      })
                    );
                    setRequestEndLocation((prevState) => ({
                      ...prevState,
                      rlkArrivalEta: value,
                      rlkArrivalEtaFormatted: formatFromJsonDate(value),
                    }));
                  }}
                  validators={
                    !allowBackDates
                      ? [
                          {
                            func: (date) => isAfter(date, new Date()),
                            message:
                              "Date and Time should be after current date and time",
                          },
                          {
                            func: (date) => {
                              if (requestEndLocation?.rlkDepartureEta) {
                                return isBefore(
                                  date,
                                  requestEndLocation?.rlkDepartureEta
                                );
                              }

                              return true;
                            },
                            message:
                              "Arrival Date should be before departure date",
                          },
                          {
                            func: (date) => {
                              const prevLocations = getPreviousLocation(null);
                              if (prevLocations) {
                                return isAfter(
                                  date,
                                  prevLocations.rlkDepartureEta
                                );
                              }

                              if (requestStartLocation?.rlkDepartureEta) {
                                return isAfter(
                                  date,
                                  requestStartLocation?.rlkDepartureEta
                                );
                              }

                              return true;
                            },
                            message:
                              "Date should be after previous location departure",
                          },
                        ]
                      : [
                          {
                            func: (date) => {
                              if (requestEndLocation?.rlkDepartureEta) {
                                return isBefore(
                                  date,
                                  requestEndLocation?.rlkDepartureEta
                                );
                              }

                              return true;
                            },
                            message:
                              "Arrival Date should be before departure date",
                          },
                          {
                            func: (date) => {
                              const prevLocations = getPreviousLocation(null);
                              if (prevLocations) {
                                return isAfter(
                                  date,
                                  prevLocations.rlkDepartureEta
                                );
                              }

                              if (requestStartLocation?.rlkDepartureEta) {
                                return isAfter(
                                  date,
                                  requestStartLocation?.rlkDepartureEta
                                );
                              }

                              return true;
                            },
                            message:
                              "Date should be after previous location departure",
                          },
                        ]
                  }
                  label="Arrival"
                  error={currentEndLocationErrors.rlkArrivalEta}
                  resetError={() =>
                    setCurrentEndLocationErrors((prevState) => {
                      const { rlkArrivalEta: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  required={true}
                />
                <DateTimePickerInput
                  readOnly={viewOnlyMode}
                  form={FORM}
                  module={MODULES.Transaction}
                  field="rlk_end_departure_eta"
                  disabled={
                    !requestStartLocation?.rlkArrivalEta ||
                    !requestStartLocation?.rlkDepartureEta
                  }
                  value={requestEndLocation?.rlkDepartureEta}
                  style={{
                    borderColor: errors.departureTime ? "red" : "",
                  }}
                  onAccept={(value) => {
                    dispatch(
                      requestActions.setEndLocation({
                        rlkDepartureEta: value,
                      })
                    );
                    setRequestEndLocation((prevState) => ({
                      ...prevState,
                      rlkDepartureEta: value,
                      rlkDepartureEtaFormatted: formatFromJsonDate(value),
                    }));
                  }}
                  validators={
                    !allowBackDates
                      ? [
                          {
                            func: (date) => isAfter(date, new Date()),
                            message:
                              "Date and Time should be after current date and time",
                          },
                          {
                            func: (date) =>
                              isAfter(date, requestEndLocation?.rlkArrivalEta),
                            message: "Date should be after arrival date",
                          },
                        ]
                      : [
                          {
                            func: (date) =>
                              isAfter(date, requestEndLocation?.rlkArrivalEta),
                            message: "Date should be after arrival date",
                          },
                        ]
                  }
                  label="Departure"
                  error={currentEndLocationErrors.rlkDepartureEta}
                  resetError={() =>
                    setCurrentEndLocationErrors((prevState) => {
                      const { rlkDepartureEta: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  required={true}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "flex-end",
                  marginTop: "5px",
                }}
              >
                <Button
                  disabled={!requestEndLocation?.rlkLocation}
                  className="ui primary right floated button"
                  label="Location Details"
                  onClick={() => {
                    openPopUp(popupConst.END_LOCATION_DETAILS);
                  }}
                  Icon={Info}
                />
              </div>
            </div>
            <div className="ui segment">
              <h4 className="ui dividing header"> Via Locaions</h4>
              <div className="two fields">
                <SearchDropdown
                  readOnly={viewOnlyMode}
                  disabled={
                    !requestStartLocation?.rlkArrivalEta ||
                    !requestStartLocation?.rlkDepartureEta
                  }
                  editMode={editMode}
                  multiGrid={true}
                  multiGridCurrentValue={requestViaLocation.locationName}
                  reset={viaSearchFieldReset}
                  form={FORM}
                  module={MODULES.Transaction}
                  field="rlk_via_location"
                  setReset={setViaSearchFieldReset}
                  ref={viaLocationRef}
                  api={getOtherRefSearchDropdown}
                  threshold={1}
                  apiDependency={{
                    type: "location_customer",
                    value: locationCustomerId?.toString(),
                  }}
                  clearable={true}
                  onClear={() => {
                    setRequestViaLocation((prevState) => ({
                      ...prevState,
                      rlkLocation: null,
                    }));
                  }}
                  onResultSelect={(data) => {
                    setRequestViaLocation((prevState) => ({
                      ...prevState,
                      rlkLocation: data,
                    }));
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_locations",
                    primaryKey: "loc_id",
                    fieldName: "loc_name",
                    id: requestViaLocation.rlkLocation,
                  }}
                  required={true}
                  label="Location"
                  error={errors.rlkLocation}
                  resetError={() =>
                    setErrors((prevState) => {
                      const { rlkLocation: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />
                <DateTimePickerInput
                  readOnly={viewOnlyMode}
                  form={FORM}
                  module={MODULES.Transaction}
                  field="rlk_via_arrival_eta"
                  disabled={
                    !requestStartLocation?.rlkArrivalEta ||
                    !requestStartLocation?.rlkDepartureEta
                  }
                  value={requestViaLocation.rlkArrivalEta}
                  style={{
                    borderColor: errors.departureTime ? "red" : "",
                  }}
                  onAccept={(value) => {
                    setRequestViaLocation((prevState) => ({
                      ...prevState,
                      rlkArrivalEta: value,
                      rlkArrivalEtaFormatted: formatFromJsonDate(value),
                    }));
                  }}
                  validators={
                    !allowBackDates
                      ? [
                          {
                            func: (date) => isAfter(date, new Date()),
                            message:
                              "Date and Time should be after current date and Time",
                          },
                          {
                            func: (date) => {
                              const prevLocations = getPreviousLocation(
                                requestViaLocation.rlkSeq
                              );
                              if (prevLocations) {
                                return isAfter(
                                  date,
                                  prevLocations.rlkDepartureEta
                                );
                              }

                              if (requestStartLocation?.rlkDepartureEta) {
                                return isAfter(
                                  date,
                                  requestStartLocation?.rlkDepartureEta
                                );
                              }

                              return true;
                            },
                            message:
                              "Date should be after previous location departure",
                          },
                          {
                            func: (date) => {
                              if (requestEndLocation?.rlkArrivalEta) {
                                return isBefore(
                                  date,
                                  requestEndLocation?.rlkArrivalEta
                                );
                              }

                              return true;
                            },
                            message:
                              "Date should be before end location arrival",
                          },
                          {
                            func: (date) => {
                              if (requestViaLocation.rlkDepartureEta) {
                                return isBefore(
                                  date,
                                  requestViaLocation.rlkDepartureEta
                                );
                              }

                              return true;
                            },
                            message:
                              "Date should be before current location depature",
                          },
                        ]
                      : [
                          {
                            func: (date) => {
                              const prevLocations = getPreviousLocation(
                                requestViaLocation.rlkSeq
                              );
                              if (prevLocations) {
                                return isAfter(
                                  date,
                                  prevLocations.rlkDepartureEta
                                );
                              }

                              if (requestStartLocation?.rlkDepartureEta) {
                                return isAfter(
                                  date,
                                  requestStartLocation?.rlkDepartureEta
                                );
                              }

                              return true;
                            },
                            message:
                              "Date should be after previous location departure",
                          },
                          {
                            func: (date) => {
                              if (requestEndLocation?.rlkArrivalEta) {
                                return isBefore(
                                  date,
                                  requestEndLocation?.rlkArrivalEta
                                );
                              }

                              return true;
                            },
                            message:
                              "Date should be before end location arrival",
                          },
                          {
                            func: (date) => {
                              if (requestViaLocation.rlkDepartureEta) {
                                return isBefore(
                                  date,
                                  requestViaLocation.rlkDepartureEta
                                );
                              }

                              return true;
                            },
                            message:
                              "Date should be before current location depature",
                          },
                        ]
                  }
                  label="Arrival"
                  error={errors.rlkArrivalEta}
                  resetError={() =>
                    setErrors((prevState) => {
                      const { rlkArrivalEta: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  required={true}
                />
                <DateTimePickerInput
                  readOnly={viewOnlyMode}
                  form={FORM}
                  module={MODULES.Transaction}
                  field="rlk_via_departure_eta"
                  disabled={
                    !requestStartLocation?.rlkArrivalEta ||
                    !requestStartLocation?.rlkDepartureEta
                  }
                  value={requestViaLocation.rlkDepartureEta}
                  style={{
                    borderColor: errors.departureTime ? "red" : "",
                  }}
                  onAccept={(value) => {
                    setRequestViaLocation((prevState) => ({
                      ...prevState,
                      rlkDepartureEta: value,
                      rlkDepartureEtaFormatted: formatFromJsonDate(value),
                    }));
                  }}
                  validators={
                    !allowBackDates
                      ? [
                          {
                            func: (date) => isAfter(date, new Date()),
                            message:
                              "Date and Time should be after current date and time",
                          },
                          {
                            func: (date) =>
                              isAfter(date, requestViaLocation.rlkArrivalEta),
                            message: "Date should be after arrival date",
                          },
                          {
                            func: (date) => {
                              if (requestEndLocation?.rlkArrivalEta) {
                                return isBefore(
                                  date,
                                  requestEndLocation?.rlkArrivalEta
                                );
                              }

                              return true;
                            },
                            message:
                              "Date should be before end location arrival",
                          },
                        ]
                      : [
                          {
                            func: (date) =>
                              isAfter(date, requestViaLocation.rlkArrivalEta),
                            message: "Date should be after arrival date",
                          },
                          {
                            func: (date) => {
                              if (requestEndLocation?.rlkArrivalEta) {
                                return isBefore(
                                  date,
                                  requestEndLocation?.rlkArrivalEta
                                );
                              }

                              return true;
                            },
                            message:
                              "Date should be before end location arrival",
                          },
                        ]
                  }
                  label="Departure"
                  error={errors.rlkDepartureEta}
                  resetError={() =>
                    setErrors((prevState) => {
                      const { rlkDepartureEta: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  required={true}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  disabled={!requestViaLocation.rlkLocation}
                  className="ui primary right floated button"
                  label="Location Details"
                  onClick={() => {
                    openPopUp(popupConst.VIA_LOCATION_DETAILS);
                  }}
                  Icon={Info}
                />
                <Button
                  template="reset"
                  onClick={(e) => {
                    setButtonClicked(true);
                  }}
                />
                <Button
                  disabled={
                    viewOnlyMode ||
                    !requestStartLocation?.rlkArrivalEta ||
                    !requestStartLocation?.rlkDepartureEta
                  }
                  template="addOrSave"
                  authenticated={true}
                  editMode={editMode}
                  module={MODULES.Transaction}
                  form={`${FORM}`}
                  create={Object.keys(currentItem).length === 0}
                  onClick={onAddClick}
                  isLoading={isAddLoading}
                />
              </div>
              <Grid
                isLoading={gridLoading}
                onRowDragEnter={onRowDragEnter}
                onRowDragEnd={onRowDragEnd}
                rowDragManaged={true}
                pagination={false}
                searchable={false}
                cellSizeStrategy="fitCellContents"
                fitContentCellls={[
                  "rlkContactPersonValue",
                  "rlkAddress",
                  "locationName",
                  "rlkEmail",
                ]}
                heading="Via Location List"
                config={[
                  { headerName: "Sequence", field: "rlkSeq", rowDrag: true },
                  {
                    headerName: "Location",
                    field: "locationName",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Arrival",
                    field: "rlkArrivalEtaFormatted",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Departure",
                    field: "rlkDepartureEtaFormatted",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },

                  {
                    headerName: "Contact Number",
                    field: "rlkContactNumber",
                  },

                  {
                    headerName: "Longitude",
                    field: "rlkLon",
                  },
                  { headerName: "Latitude", field: "rlkLat" },
                  {
                    field: "Edit",
                    filter: true,
                    cellRenderer: ButtonRenderer,
                    cellRendererParams: (params) => ({
                      consider: AUTH_TYPES.CREATE,
                      clickHandler: () => {
                        setCurrentItem(params.data);
                      },
                      label: viewOnlyMode ? "View" : "Edit",
                      authenticated: true,
                      form: `${FORM}`,
                      module: MODULES.Transaction,
                      editMode: editMode,
                    }),
                  },
                  {
                    field: "Delete",
                    filter: true,
                    cellRenderer: DeleteButtonRenderer,
                    cellRendererParams: (params) => ({
                      consider: AUTH_TYPES.DELETE,
                      clickHandler: () => {
                        if (params.data.rlkId) {
                          setItems((prevState) =>
                            prevState.filter(
                              (item) => item.rlkId !== params.data.rlkId
                            )
                          );
                          dispatch(
                            requestActions.removeLocation({
                              rlkId: params.data.rlkId,
                              location: params.data.rlkLocation,
                            })
                          );
                        } else {
                          setItems((prevState) =>
                            prevState.filter(
                              (item) => item.id !== params.data.id
                            )
                          );
                          dispatch(
                            requestActions.removeUnPersistedLocation({
                              id: params.data.id,
                              location: params.data.rlkLocation,
                            })
                          );
                        }
                        setSeq((prevState) => --prevState);
                      },
                      label: "Delete",
                      disabled: viewOnlyMode,
                      className: "ui red button",
                      authenticated: true,
                      form: `${FORM}`,
                      module: MODULES.Transaction,
                      editMode:
                        params.data.rlkId !== null &&
                        isNumber(params.data.rlkId),
                    }),
                  },
                ]}
                content={items}
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "flex-end",
                  marginTop: "5px",
                }}
              >
                {/* <Button
                  disabled={
                    !requestStartLocation?.rlkArrivalEta ||
                    !requestStartLocation?.rlkDepartureEta
                  }
                  className="ui primary right floated button"
                  label="Show Map Location"
                  onClick={onShowLocation}
                  Icon={MapPin}
                /> */}
              </div>
            </div>
            {validationErrors && validationErrors.length > 0 && (
              <UIMessage type="negative" width="100%" centered={false}>
                <div className="content">
                  <div className="header">
                    There was some errors with your locations
                  </div>

                  <p>
                    <div className="content">
                      <ul>
                        {validationErrors.map((value) => (
                          <li>{value.error}</li>
                        ))}
                      </ul>
                    </div>
                  </p>
                </div>
              </UIMessage>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default QuickRequestLocation;
